// extracted by mini-css-extract-plugin
export default {"container":"textArea_container__zjodY","error":"textArea_error__ct3NN","errorMessage":"textArea_errorMessage__drFPv"};